<template>
  <div class="row">
    <div class="col col-8">
      <component :is="calculator" />
      <CalculationSteps v-if="show" />
    </div>
    <Navigation calculators />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ConfidenceInterval from './ConfidenceInterval.vue';
import MeanMedianMode from './MeanMedianMode.vue';
import Skewness from './Skewness.vue';
import Kurtosis from './Kurtosis.vue';
import Variance from './Variance.vue';
import StandardDeviation from './StandardDeviation.vue';
import CoefficientOfVariation from './CoefficientOfVariation.vue';
import LinearRegression from './LinearRegression.vue';
import PValue from './PValue.vue';
import HypothesisTest from './HypothesisTest.vue';
import DifferenceInMeans from './DifferenceInMeans.vue';
import Navigation from '../../Navigation';
import CalculationSteps from '../CalculationSteps';

export default {
  components: {
    ConfidenceInterval,
    MeanMedianMode,
    Skewness,
    Kurtosis,
    Variance,
    StandardDeviation,
    CoefficientOfVariation,
    LinearRegression,
    PValue,
    HypothesisTest,
    DifferenceInMeans,
    Navigation,
    CalculationSteps,
  },
  computed: {
    ...mapState('calculators', ['calculator', 'showSteps']),
    show() {
      if ((this.calculator === 'meanMedianMode' && !this.showSteps) || this.calculator === 'pValue') {
        return false;
      }
      return true;
    },
  },
  watch: {
    calculator() {
      this.$store.commit('calculators/showSteps', false);
    },
  },
};
</script>
